import type { DataScope, EffectiveRole, PermissionGrant } from '@/core/types/auth';

export const permissionCodes = Object.freeze({
  tenancyRead: 'tenancy.read',
  identityMeRead: 'identity.me.read',
  leadsRead: 'leads.read',
  leadsCreate: 'leads.create',
  leadsUpdate: 'leads.update',
  leadsAssign: 'leads.assign',
  leadsDuplicateCheck: 'leads.duplicate-check',
  directoryRead: 'directory.read',
  reportsLeadsRead: 'reports.leads.read',
  leadsQualify: 'leads.qualify',
  leadsDisqualify: 'leads.disqualify',
  leadsConvert: 'leads.convert',
  contactsRead: 'contacts.read',
  contactsCreate: 'contacts.create',
  accountsRead: 'accounts.read',
  accountsCreate: 'accounts.create',
  activitiesRead: 'activities.read',
  activitiesCreate: 'activities.create',
  opportunitiesRead: 'opportunities.read',
  opportunitiesCreate: 'opportunities.create',
  campaignsRead: 'campaigns.read',
  campaignsManage: 'campaigns.manage',
  campaignsApprove: 'campaigns.approve',
  campaignsSend: 'campaigns.send',
  campaignsReportsRead: 'campaigns.reports.read',
});

const scopeWeight: Record<DataScope, number> = {
  explicit: 0,
  own: 1,
  team: 2,
  branch: 3,
  tenant: 4,
};

export const hasPermission = (
  permissions: PermissionGrant[],
  code: string,
  minimumScope?: DataScope,
): boolean => {
  const grant = permissions.find((item) => item.code === code);
  if (!grant) return false;
  return minimumScope ? scopeWeight[grant.scope] >= scopeWeight[minimumScope] : true;
};

export const getPermissionScope = (
  permissions: PermissionGrant[],
  code: string,
): DataScope | null => permissions.find((item) => item.code === code)?.scope ?? null;

export const getEffectiveRole = (permissions: PermissionGrant[]): EffectiveRole => {
  if (hasPermission(permissions, permissionCodes.leadsAssign)) return 'manager';

  const leadScope = getPermissionScope(permissions, permissionCodes.leadsRead);
  return leadScope === 'tenant' || leadScope === 'branch' || leadScope === 'team'
    ? 'manager'
    : 'employee';
};
